import { InformationCircleIcon } from '@heroicons/react/24/outline';

const RULES = [
    'O day off é no próprio dia do seu aniversário, de segunda a sexta.',
    'Ele não pode ser trocado por outra data.',
    'Se o aniversário cair em fim de semana, feriado ou férias, o dia é inválido e deve ser verificado com o DP.',
    'Precisa da aprovação do gestor Raro e do cliente do projeto.',
];

export function DayOffRules() {
    return (
        <aside className="rounded-2xl border border-raro-gray-200 bg-raro-gray-50 px-5 py-4" aria-label="Como funciona o day off">
            <h2 className="flex items-center gap-2 text-sm font-semibold text-raro-gray-800">
                <InformationCircleIcon className="h-5 w-5 text-primary-600" aria-hidden="true" />
                Como funciona
            </h2>
            <ul className="mt-2 list-disc space-y-1 pl-6 text-sm text-raro-gray-700">
                {RULES.map(rule => (
                    <li key={rule}>{rule}</li>
                ))}
            </ul>
        </aside>
    );
}
